import '@fontsource-variable/space-grotesk';
import '@fontsource-variable/jetbrains-mono';
import './styles/tokens.css';
import './styles/base.css';
import './styles/components.css';
import './styles/layout.css';
import './styles/typing.css';
import './styles/pages.css';
import './styles/race.css';
import './styles/kites.css';
import './styles/icecream.css';
import { createLayout } from './app/layout';
import { startRouter } from './app/router';
import { routes } from './app/routes';
import { bootstrap } from './app/store';

async function main(): Promise<void> {
  const app = document.getElementById('app');
  if (!app) return;
  await bootstrap();
  const { root, main: outlet } = createLayout();
  app.replaceChildren(root);
  startRouter(outlet, routes);
}

void main();
